/**
 * @file DetailsPanel.jsx
 * @author Rishikesh
 * @date 2024-09-09
 * @description Component of dashboard to manage course details
 */
import React from "react";
import { Box, Stack, Typography, Skeleton, Divider } from "@mui/material";
import { CourseSelection } from "./CourseSelection";
import { CountrySelection } from "./CountrySelection";

export const DetailsPanel = ({
  isLoading,
  countryList,
  courseList,
  selectedCountry,
  setSelectedCountry,
  courseCountry,
  setCourseCountry,
}) => {
  return (
    <Box
      flex={1}
      height="100%"
      borderRadius="12px"
      px="8px"
      py={3}
      bgcolor="#F7F7F7"
      display="flex"
      flexDirection="column"
    >
      <Stack
        pb={1}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        {isLoading ? (
          <Skeleton variant="rounded" width={140} height={24} />
        ) : (
          <Typography fontWeight={500} fontSize={20} color="#222222">
            Choose Countries and courses
          </Typography>
        )}
      </Stack>
      <Divider />
      <Stack direction="row" height="100%" display="flex">
        <CountrySelection
          isLoading={isLoading}
          countryList={countryList}
          selectedCountry={selectedCountry}
          setSelectedCountry={setSelectedCountry}
          courseCountry={courseCountry}
          setCourseCountry={setCourseCountry}
        />
        <Divider
          sx={{ mb: 4 }}
          orientation="vertical"
          variant="middle"
          flexItem
        />
        <CourseSelection
          isLoading={isLoading}
          selectedCountry={selectedCountry}
          courses={courseList}
          courseCountry={courseCountry}
          setCourseCountry={setCourseCountry}
        />
      </Stack>
    </Box>
  );
};
